import PropTypes from 'prop-types';
import React from 'react';
import Dock from 'react-dock';
import { Common } from 'ws-scripts/modules/common';
import {
	VEHICLE_INCENTIVE,
	MANUFACTURER_OFFER,
	DEALER_OFFER,
	DISCLAIMER,
	OFFER_VALID,
	THROUGH
} from '../constants/constants';
import { closeSpecialsDetailsEvent } from '../utils/analytics';

export default class IncentiveDock extends React.Component {
	constructor(props) {
		super(props);
		this.close = this.close.bind(this);
		this.body = null;
	}

	componentDidMount() {
		const bodyWindow = document.getElementsByTagName('body')[0];
		this.body = bodyWindow;
	}

	componentWillReceiveProps(nextProps) {
		if (
			this.props.isModalVisible !== nextProps.isModalVisible &&
			this.body !== undefined
		) {
			if (nextProps.isModalVisible) {
				this.body.style.overflow = 'hidden';
			} else {
				this.body.style.overflow = '';
			}
		}
	}

	close() {
		const { widgetName, windowId } = this.props;
		closeSpecialsDetailsEvent(widgetName, windowId);
		this.props.setModalStateData({}, false);
	}

	render() {
		const {
			disclaimer,
			conditional,
			title,
			offerDetails,
			effectiveDate,
			expirationDate
		} = this.props.incentive;

		const closeButton = (
			<button
				type="button"
				aria-label="Close"
				className="close text-muted font-weight-bold "
				onClick={this.close.bind(this)}
			>
				<i className="ddc-icon ddc-icon-close" aria-hidden="true" />
			</button>
		);

		let incentiveDisclaimer = '';

		if (disclaimer) {
			incentiveDisclaimer = (
				<Common
					render={({ labels }) => {
						return (
							<div className="text-muted mt-4">
								<h4>{labels.get(DISCLAIMER)}</h4>
								<p>{disclaimer}</p>
							</div>
						);
					}}
				/>
			);
		}

		const dialogBody = (
			<Common
				render={({ labels }) => {
					let offer = MANUFACTURER_OFFER;
					if (conditional) {
						offer = DEALER_OFFER;
					}
					return (
						<div className="border-top">
							<h4 className="text-muted mt-4 mb-0">
								{labels.get(offer)}
							</h4>
							<h2 className="mt-0">{title}</h2>
							<p>
								<span className="d-block">{offerDetails}</span>
								<span className="d-block">
									{labels.get(OFFER_VALID)} {effectiveDate}{' '}
									{labels.get(THROUGH)} {expirationDate}
								</span>
							</p>
							{incentiveDisclaimer}
						</div>
					);
				}}
			/>
		);

		const dialogHeader = (
			<Common
				render={({ labels }) => {
					return (
						<div className="mt-4 mb-5">
							{closeButton}
							<div className="text-center">
								<h4>{labels.get(VEHICLE_INCENTIVE)}</h4>
							</div>
						</div>
					);
				}}
			/>
		);

		let dock = null;
		if (this.props.isModalVisible) {
			const isFluid = true;
			const position = 'right';
			const size = 0.9;
			const duration = 2000;

			dock = (
				<Dock
					isVisible={this.props.isModalVisible}
					position={position}
					size={size}
					fluid={isFluid}
					duration={duration}
					onVisibleChange={this.close.bind(this)}
				>
					<div className="m-3">
						{dialogHeader}
						{dialogBody}
					</div>
				</Dock>
			);
		}
		return <div>{dock}</div>;
	}
}

IncentiveDock.propTypes = {
	incentive: PropTypes.shape({
		key: PropTypes.string,
		title: PropTypes.string,
		label: PropTypes.string,
		offerDetails: PropTypes.string,
		shortTitle: PropTypes.string,
		disclaimer: PropTypes.string,
		effectiveDate: PropTypes.string,
		expirationDate: PropTypes.string,
		conditional: PropTypes.bool,
		error: PropTypes.string
	}).isRequired,
	isModalVisible: PropTypes.bool.isRequired,
	setModalStateData: PropTypes.func.isRequired,
	windowId: PropTypes.string.isRequired,
	widgetName: PropTypes.string.isRequired
};



// WEBPACK FOOTER //
// ./src/components/IncentiveDock.jsx